import { MailOutline, PlaceOutlined, WhatsApp } from "@mui/icons-material";
import { useMediaQuery } from "@mui/material";

import { useTheme } from "../../providers/ThemeContext";
import { useI18n } from "../../languages/providers/I18nProvider";
import { ContactStyles } from "./ContactStyles";
import { GlobalStyles } from "../../styles/GlobalStyles";
import { footerData } from "../../components/website/footer/FooterContent";
import { buildWhatsAppHref, firstString } from "../../utils/whatsapp";
import ContactForm from "../../components/form/ContactForm";
import SmallCard from "../../components/cards/smallCard/SmallCard";
import HeaderSection from "../../components/common/HeaderSection";
import { breadcrumbSchema } from "../../config/seoConfig";
import SEO from "../../components/common/SEO";
import WhatsAppFab from "../../components/common/WhatsAppFab";

const WHATSAPP_NUMBERS = [
  { display: "+971 55 407 1164", digits: "971554071164" }, // existing
  { display: "+971 55 407 1163", digits: "971554071163" },
  { display: "+971 52 268 5538", digits: "971522685538" },
];

export default function ContactPage() {
  const { theme } = useTheme();
  const { t, lang } = useI18n();
  const isMobile = useMediaQuery("(max-width: 900px)");

  const s = ContactStyles(theme, isMobile);
  const g = GlobalStyles(theme);

  const waUrl = buildWhatsAppHref(
    footerData.reach?.whatsappPhone,
    footerData.reach?.mobile,
    t("contact:messages:whatsapp"),
  );

  const waLabel =
    (!/^(https?:\/\/|whatsapp:\/\/)/i.test(
      footerData.reach?.whatsappPhone ?? "",
    ) &&
      footerData.reach?.whatsappPhone) ||
    firstString(footerData.reach?.mobile) ||
    "Open WhatsApp";

  return (
    <>
      <SEO
        title={t("seo:contact:title")}
        description={t("seo:contact:description")}
        lang={lang}
        schema={[
          breadcrumbSchema(lang, [
            { name: t("nav:home"), path: "" },
            { name: t("nav:contact"), path: "/contact" },
          ]),
        ]}
      />

      <main style={g.page}>
        <div style={s.wrap}>
          <div style={s.grid}>
            {/* LEFT: title + cards */}
            <div>
              <HeaderSection
                eyebrow={t("contact:eyebrow")}
                title={t("contact:titleLine1")}
                subtitle={t("contact:subtitle")}
              />

              <div style={s.row}>
                {WHATSAPP_NUMBERS.map((n, i) => (
                  <SmallCard
                    key={n.digits}
                    href={`https://wa.me/${n.digits}?text=${encodeURIComponent(t("contact:messages:whatsapp"))}`}
                    title={"WhatsApp " + (i + 1)}
                    text={n.display}
                    icon={<WhatsApp fontSize="small" />}
                    tooltipTitle={`WhatsApp ${n.display}`}
                    newTab={true}
                    textDir="ltr"
                  />
                ))}

                <SmallCard
                  href="mailto:connect@creationarts.com"
                  title={t("contact:mailUsAt")}
                  text="connect@creationarts.com"
                  icon={<MailOutline fontSize="small" />}
                  tooltipTitle="Email us"
                  newTab={false}
                  textDir="ltr"
                />

                <SmallCard
                  href={footerData.reach.mapUrl}
                  title={t("footer:labels:address")}
                  text={t("contact:data:address")}
                  icon={<PlaceOutlined fontSize="small" />}
                  tooltipTitle={t("contact:data:address")}
                  newTab={true}
                />
              </div>
            </div>

            <ContactForm />
          </div>
        </div>

        <WhatsAppFab
          phone="971554071164"
          message={t("contact:messages:whatsapp")}
          ariaLabel={t("common:chatWhatsApp")}
          tooltipText={t("contact:messages:whatsappTooltip")}
          bottom={22}
          left={22}
        />
      </main>
    </>
  );
}
